<template>
  <bita-modal :id="modalId" :title="title" :isLoading="isLoading">
    <div slot="body">
      <bita-form ref="form">
        <div slot="body">
          <label>فایل اکسل </label>
          <input
            class="form-control"
            type="file"
            id="file"
            ref="file"
            accept=".xls,.xlsx"
            @change="handleFileUpload"
          />
          <div class="card bg-warning px-2 pt-3 mt-4">
            <span class="mb-2 h6">قالب فایل</span>
            <ul>
              <li>
                ستون اول(A) نام
              </li>
              <li>
                ستون دوم(B) نام خانوادگی میباشد
              </li>
              <li>
                ستون سوم(C) کدملی میباشد
              </li>
              <li>
                ستون چهارم(D) شماره همراه میباشد
              </li>
              <li>
                ستون پنجم(E) اولویت میباشد
              </li>
            </ul>
          </div>
          <bita-bootbutton
            class="mt-4"
            type="primary"
            title="ثبت"
            icon="fas fa-check"
            :isLoading="isLoading"
            @click.native="handleSubmit"
          />
        </div>
      </bita-form>
    </div>
  </bita-modal>
</template>
<script>
export default {
  props: {
    modalId: {},
    title: {},
    isLoading: {},
  },
  data() {
    return {
      colWidth: "col-lg-3",
      drivers: [],
      terminalId: "",
      form: {
        file: "",
      },
    };
  },
  methods: {
    handleFileUpload() {
      this.form.file = this.$refs.file.files[0];
    },
    handleSubmit() {
      if (this.form.file) {
        this.$emit("on-submit", this.form);
      }
    },
  },
};
</script>
